import React from 'react';


const WorkTogether = () => {
    return (
        <div className="border-[4px] border-black shadow-nero bg-orange-400 p-8 md:p-10 mb-8 relative overflow-hidden">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 relative z-10">
                <div className="max-w-2xl">
                    <h2 className="text-3xl md:text-5xl font-bold text-black mb-4 border-b-0">
                        Want to build something together?
                    </h2>
                    <p className="text-xl text-slate-900 font-medium">
                        I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.
                    </p>
                </div>
                <div className="flex-shrink-0">
                    <a href="mailto:hello@jasen.dev" className="btn-primary inline-block text-center">
                        Contact Me
                    </a>
                </div>
            </div>
        </div>
    );
};

export default WorkTogether;
